import { put } from "@redux-saga/core/effects";
import { deleteBulkOptionsFailure, deleteBulkOptionsSuccess } from "../actionCreaters";

import { FieldsService } from "./../../../services/fields";
import { DeleteOptionRequestActionType, optionsResponse } from "./../types";

export function* deleteBulkOptionsSaga({ payload: { fieldId } }: DeleteOptionRequestActionType) {
    try {
        const {
            data: { data },
        }: optionsResponse = yield FieldsService.deleteBulkOptions(fieldId);

        yield put(deleteBulkOptionsSuccess({ fieldId, options: data.options }));
    } catch (error) {
        yield put(deleteBulkOptionsFailure({ fieldId }));
    }
}
